import React, { forwardRef, memo } from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

export const IconHeadingOne = memo(
  forwardRef((props, ref) => (
    <SvgIcon
      {...props}
      ref={ref}
      viewBox="0 0 24 24"
    >
      <path
        d="M10.5625 11.1367V12.0566H5.94531V11.1367H10.5625ZM6.12109 7.46875V16H4.99023V7.46875H6.12109ZM11.5469 7.46875V16H10.4219V7.46875H11.5469ZM16.8379 7.42188V16H15.7539V8.77539L13.5684 9.57227V8.59375L16.668 7.42188H16.8379Z"
        fill="currentColor"
      />
    </SvgIcon>
  ))
);

IconHeadingOne.displayName = 'IconHeadingOne';
